import styled from '@emotion/styled'

export const V2L1LogModalActionButton = styled.button(({theme}) => ({
	all: 'unset',
	backgroundColor: theme.colors.transparent,
	borderRadius: theme.borderRadius,
	border: `1px solid ${theme.colors.white}`,
	padding: '.25rem 1rem',
	cursor: 'pointer',
}))
